import { Component, Input, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { ScriptConfiguration, ScriptingLanguageType } from '../cpq-scripting-codemirror/cpq-scripting.model';
import { IScriptHistoryService } from '../common/interfaces/IScriptHistoryService.interface';
import { CompareData } from '../cpq-text-compare/text-compare.model';
import { ScriptHistoryDatatableComponent } from './script-history-datatable/script-history-datatable.component';

@Component({
    selector: 'cpq-script-history',
    templateUrl: './cpq-script-history.component.html',
    styleUrls: ['./cpq-script-history.component.scss'],
    standalone: false
})
export class CpqScriptHistoryComponent {


  @Input('scriptHistoryService') scriptHistoryService: IScriptHistoryService;
  @Input('scriptId') scriptId: number;
  @Input('scriptConfig') scriptConfig: ScriptConfiguration;
  @Input('languageType') languageType: ScriptingLanguageType = ScriptingLanguageType.IronPython;
  @ViewChild('datatable', { static: true }) datatable: ScriptHistoryDatatableComponent;

  public scriptHistoryRecordId: number;
  public scriptHistoryRecordVersionNumber: number;
  public isScriptDetailsAvailable: boolean;
  public originalObject: CompareData;
  public compareObject: CompareData;
  public isCompareViewAvailable: boolean;

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  public showRecordDetail(scriptHistoryRecord: {scriptRecordId: number, scriptRecordVersionNumber: number}) {
    if(scriptHistoryRecord) {
      this.scriptHistoryRecordId = scriptHistoryRecord.scriptRecordId;
      this.scriptHistoryRecordVersionNumber = scriptHistoryRecord.scriptRecordVersionNumber;
      this.resetDetailsAndComparations();
      this.isScriptDetailsAvailable = true;
    } else {
      this.resetDetailsAndComparations();
    }
  }

  public showComparedRecords(data: {originalObject: CompareData, compareObject: CompareData}) {
    if (data) {
      this.originalObject = data.originalObject;
      this.compareObject = data.compareObject;
      this.resetDetailsAndComparations();
      this.isCompareViewAvailable = true;
    } else {
      this.resetDetailsAndComparations();
    }
  }
  
  public refreshHistoryRecords() {
    this.datatable.filter.emitChange();
  }
  
  private resetDetailsAndComparations() {
    this.isScriptDetailsAvailable = false;
    this.isCompareViewAvailable = false;
    this.changeDetectorRef.detectChanges();
  }


}
